module.exports = __webpack_public_path__ + "media/3.4cba9d4c.wav";